// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"wY-z","subtitle":"xY-z","wrapper":"yY-z","leftArrow":"zY-z","rightArrow":"AY-z"};